"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.config = void 0;
/** @module deprecated */
var localstorage_logger_1 = require("localstorage-logger");
/**
 * Get config for specified deployment.
 * @param d Deployment
 * @return Config
 * @throws Error if no config for deployment.
 */
function configFromDeployment(d, b) {
    var logObject = null;
    switch (d) {
        case 'dev':
            console.log('Dev config loaded');
            logObject = localstorage_logger_1.default({
                logName: 'bryx-dev-log',
                maxLogSizeInBytes: 500 * 1024,
            });
            return {
                baseUrl: b,
                serverType: 'dev',
                version: VERSION,
                log: logObject,
                info: logObject.info,
                warn: logObject.warn,
                debug: logObject.debug,
                error: logObject.error,
            };
        case 'k8s':
            console.log('K8s config loaded');
            logObject = localstorage_logger_1.default({
                logName: 'bryx-dev-log',
                maxLogSizeInBytes: 500 * 1024,
            });
            return {
                baseUrl: b,
                serverType: 'k8s',
                version: VERSION,
                log: logObject,
                info: logObject.info,
                warn: logObject.warn,
                debug: logObject.debug,
                error: logObject.error,
            };
        case 'staging':
            console.log('Staging config loaded');
            logObject = localstorage_logger_1.default({
                logName: 'bryx-staging-log',
                maxLogSizeInBytes: 500 * 1024,
            });
            return {
                baseUrl: b,
                serverType: 'staging',
                version: VERSION,
                log: logObject,
                info: logObject.info,
                warn: logObject.warn,
                debug: logObject.debug,
                error: logObject.error,
            };
        case 'production':
            console.log('Prod config loaded');
            logObject = localstorage_logger_1.default({
                logName: 'bryx-prod-log',
                maxLogSizeInBytes: 500 * 1024,
            });
            return {
                baseUrl: b,
                serverType: 'prod',
                version: VERSION,
                log: logObject,
                info: logObject.info,
                warn: logObject.warn,
                debug: logObject.debug,
                error: logObject.error,
            };
        case 'test':
            return {
                baseUrl: 'localhost',
                serverType: 'test',
                version: '0.0.0',
                log: {},
                info: function (m) { return null; },
                warn: function (m) { return null; },
                debug: function (m) { return null; },
                error: function (m) { return null; },
            };
        default:
            throw new Error("Bad deployment: " + d + " -- No config for this deployment");
    }
}
/**
 * Config for deployment.
 * @type Config
 */
exports.config = configFromDeployment(process.env.NODE_ENV, process.env.BASE_URL || '');
//# sourceMappingURL=config.js.map